import { CommunityCoverImageViewModel } from "client/Api/Communities/community";
import { MediaPlaceholder } from "client/Components";
import { ReactElement } from "react";
import { ImageWithFocalPoint } from "../FocalPointDialog/ImageWithFocalPoint";
import { getCommunityImageUrl } from "./common";

export type CommunityCoverImageProps = {
	image: CommunityCoverImageViewModel | null;
};

export const CommunityCoverImage = (props: CommunityCoverImageProps): ReactElement => {
	const {
		image
	} = props;

	if (!image) {
		return (
			<MediaPlaceholder
				icon="users"
				size="large"
				trackingId="cover-image-placeholder"
			/>
		);
	}

	return (
		<ImageWithFocalPoint
			src={getCommunityImageUrl(image.file.blobId)}
			focalPoint={image?.focalPoint}
			height="fill"
		/>
	);
};
CommunityCoverImage.displayName = "CommunityCoverImage";
